import { TestIdDomain } from 'constants/testIds';

const UnderwritingTestIdsScope = {
  ADD_BROKER_CONDITION_FORM: 'add-broker-condition-form',
  BROKER_CONDITION_FORM: 'broker-condition-form',
  DOCUMENT_EXPIRATION_DATES: 'document-expiration-dates',
  DOCUMENT_EXPIRATION_DATE_FORM: 'document-expiration-date-form',
  GENERAL_FORM: 'general-form',
  LOAN_DENIAL_FORM: 'loan-denial-form',
  SCHEDULED_BUNDLE_HISTORY: 'scheduled-bundle-history',
};

export const UnderwritingTestIds = {
  // AddBrokerConditionForm
  ADD_BROKER_CONDITION_FORM: `${TestIdDomain.UNDERWRITING}.${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}`,
  ADD_BROKER_CONDITION_FORM_BORROWER_INTERNAL_TEXT_INPUT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.borrower-internal-text-input`,
  ADD_BROKER_CONDITION_FORM_INTERNAL_TEXT_INPUT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.internal-text-input`,
  ADD_BROKER_CONDITION_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.submit-button`,

  // AddConditionFormTaskType
  ADD_CONDITION_FORM_DESCRIPTION_INPUT: 'add-condition-form.description-input',

  // CancelSendingBundlePopup
  BROKER_CONDITION_FORM_CANCEL_CD_BUNDLE_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.cancel-cd-bundle-button`,

  // Conditions
  LOAN_CONDITIONS_ADD_BUTTON: 'loan-conditions.add-button',

  // GeneralForm
  GENERAL_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.GENERAL_FORM}.cancel-button`,
  GENERAL_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.GENERAL_FORM}.submit-button`,

  // KeyDates
  KEY_DATES_SECTION: 'key-dates.section',

  // LoanConditionTable
  LOAN_CONDITION_TABLE: `${TestIdDomain.UNDERWRITING}.loan-condition-table`,

  // LoanConditionTableItem
  BROKER_CONDITION_FORM_SIGN_OFF_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.sign-off-button`,
  BROKER_CONDITION_FORM_DELETE_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.delete-button`,
  BROKER_CONDITION_FORM_REJECT_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.reject-button`,
  BROKER_CONDITION_FORM_UNSIGN_OFF_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.unsign-off-button`,

  // LoanDenialForm
  LOAN_DENIAL_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.cancel-button`,
  getLoanDenialRowId: id => `loan-denial.row-${id}`,
  LOAN_DENIAL_FORM_SUBMIT_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.submit-button`,

  // NotesForm
  NOTES_FORM_NOTES_INPUT: 'notes-form.notes-input',

  // UWReports
  UW_REPORTS_GENERATE_NEW_REPORT_BUTTON: 'uw-reports.generate-new-report-button',

  // DocumentExpirationDates
  DOCUMENT_EXPIRATION_DATES_ADD_BUTTON: `${UnderwritingTestIdsScope.DOCUMENT_EXPIRATION_DATES}.add-button`,

  // DocumentExpirationDateForm
  DOCUMENT_EXPIRATION_DATE_FORM_TITLE_INPUT: `${UnderwritingTestIdsScope.DOCUMENT_EXPIRATION_DATE_FORM}.title-input`,
  DOCUMENT_EXPIRATION_DATE_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.DOCUMENT_EXPIRATION_DATE_FORM}.cancel-button`,
  DOCUMENT_EXPIRATION_DATE_FORM_SAVE_BUTTON: `${UnderwritingTestIdsScope.DOCUMENT_EXPIRATION_DATE_FORM}.save-button`,

  // ScheduledBundleHistoryTable
  SCHEDULED_BUNDLE_HISTORY_VIEW_DOCUMENTS_BUTTON: `${UnderwritingTestIdsScope.SCHEDULED_BUNDLE_HISTORY}.view-documents-button`,
  SCHEDULED_BUNDLE_HISTORY_CANCEL_BUTTON: `${UnderwritingTestIdsScope.SCHEDULED_BUNDLE_HISTORY}.cancel-button`,

  // AddConditionFormTaskType (inline)
  BROKER_CONDITION_FORM_TASK_TYPE_INFO_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.task-type-info-button`,

  // LoanConditionTableItem (inline)
  BROKER_CONDITION_FORM_MESSAGE_INPUT: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.message-input`,
  BROKER_CONDITION_FORM_INTERNAL_TEXT_INPUT: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.internal-text-input`,
  BROKER_CONDITION_FORM_REJECTION_REASON_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.rejection-reason-button`,
  BROKER_CONDITION_FORM_SLA_INFO_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.sla-info-button`,
  BROKER_CONDITION_FORM_EDIT_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.edit-button`,
  BROKER_CONDITION_FORM_CANCEL_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.cancel-button`,
  BROKER_CONDITION_FORM_COLLAPSE_BUTTON: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.collapse-button`,

  // LoanDenialForm (inline)
  LOAN_DENIAL_FORM_NEW_REASON_SELECT: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.new-reason-select`,
  LOAN_DENIAL_FORM_ADD_REASON_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.add-reason-button`,

  // Dynamic
  getLoanBundleHistoryViewDocumentsButtonId: formBundleSignatureRequestId =>
    `form-bundle-${formBundleSignatureRequestId}.view-documents-button`,
  getScheduledBundleHistoryInfoId: id =>
    `${UnderwritingTestIdsScope.SCHEDULED_BUNDLE_HISTORY}.info-${id}-button`,
  getConditionMessageInputId: conditionId => `condition-${conditionId}.message-input`,
  getConditionNumberInputId: conditionId => `condition-${conditionId}.number-input`,
  getConditionDeleteButtonId: conditionId => `condition-${conditionId}.delete-button`,
  getConditionBorrowerMessageInputId: conditionId =>
    `condition-${conditionId}.borrower-message-input`,
  getConditionSubCompanyMessageInputId: conditionId =>
    `condition-${conditionId}.sub-company-message-input`,
  getLoanDenialCreditCheckboxId: id => `row-${id}.credit-checkbox`,
  getLoanDenialBorrowerCheckboxId: (id, borrowerKey) =>
    `row-${id}.borrower-${borrowerKey}-checkbox`,
  getLoanDenialAffiliateCheckboxId: id => `row-${id}.affiliate-checkbox`,
  getLoanDenialDeleteButtonId: id => `row-${id}.delete-button`,
  getLoanDenialMobileDeleteButtonId: id => `row-${id}.mobile-delete-button`,
  getUwReportItemId: reportId => `uw-report-item.report-${reportId}`,
  getUwReportItemHeaderId: reportId => `uw-report-item-${reportId}.header`,
  getConditionHeaderId: priorTo => `condition-${priorTo}.header`,
  getFormBundleHistoryHeaderId: formBundleSignatureRequestId =>
    `form-bundle-${formBundleSignatureRequestId}.history-header`,
  getFormBundleTableId: formBundleSignatureRequestId =>
    `form-bundle.table-${formBundleSignatureRequestId}`,
  getTableHeadLabelId: id => `table-head.label-${id}`,

  // Notes (inline)
  NOTES_DATA_BUTTON: `${TestIdDomain.UNDERWRITING}.notes-data-button`,

  // LoanDenial (inline)
  LOAN_DENIAL_FORM_LOAN_DENIAL_REASON_DATA_BUTTON: `${UnderwritingTestIdsScope.LOAN_DENIAL_FORM}.loan-denial-reason-data-button`,

  // AddConditionFormTaskType (inline)
  BROKER_CONDITION_FORM_STATE_SELECT: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.state-select`,
  BROKER_CONDITION_FORM_FORM_ID_SELECT: `${UnderwritingTestIdsScope.BROKER_CONDITION_FORM}.form-id-select`,

  // SuspenseReason (inline)
  SUSPENSE_REASON_SECTION: `${TestIdDomain.UNDERWRITING}.suspense-reason-section`,

  // General (inline)
  GENERAL_FORM_LOAN_EXPIRATION_DATE_DATA_BUTTON: `${UnderwritingTestIdsScope.GENERAL_FORM}.loan-expiration-date-data-button`,
  ADD_BROKER_CONDITION_FORM_ASSIGNEE_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.assignee-select`,
  ADD_BROKER_CONDITION_FORM_ASSIGNEE_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.assignee-option`,
  ADD_BROKER_CONDITION_FORM_ENTITY_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.entity-select`,
  ADD_BROKER_CONDITION_FORM_ENTITY_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.entity-option`,
  ADD_BROKER_CONDITION_FORM_FORM_TYPE_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.form-type-select`,
  ADD_BROKER_CONDITION_FORM_FORM_TYPE_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.form-type-option`,
  ADD_BROKER_CONDITION_FORM_PRIOR_TO_AUTOCOMPLETE_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.prior-to-autocomplete-select`,
  ADD_BROKER_CONDITION_FORM_PRIOR_TO_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.prior-to-option`,
  ADD_BROKER_CONDITION_FORM_CONDITIONS_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.conditions-select`,
  ADD_BROKER_CONDITION_FORM_CONDITIONS_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.conditions-option`,
  ADD_BROKER_CONDITION_FORM_CONDITION_SETS_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.condition-sets-select`,
  ADD_BROKER_CONDITION_FORM_CONDITION_SETS_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.condition-sets-option`,
  ADD_BROKER_CONDITION_FORM_PRIOR_TO_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.prior-to-select`,
  ADD_BROKER_CONDITION_FORM_STATUS_SELECT: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.status-select`,
  ADD_BROKER_CONDITION_FORM_STATUS_OPTION: `${UnderwritingTestIdsScope.ADD_BROKER_CONDITION_FORM}.status-option`,
};
